export var msgHandlers: MsgHandler[] = [];
export var msgHandlersNumber: number[] = [];

export abstract class MsgHandler {
  constructor(UserActionNumber: number) {
    msgHandlers.push(this);
    msgHandlersNumber.push(UserActionNumber);
  }

  abstract handleMsg(msgObj: any): void;

  findHandler(UserActionNumber: number) {
    return msgHandlers[msgHandlersNumber.indexOf(UserActionNumber)];
  }
}
